import { render, staticRenderFns } from "./ClaimActionDialog.vue?vue&type=template&id=ed18ec08&scoped=true"
import script from "./ClaimActionDialog.vue?vue&type=script&lang=js"
export * from "./ClaimActionDialog.vue?vue&type=script&lang=js"
import style0 from "./ClaimActionDialog.vue?vue&type=style&index=0&id=ed18ec08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed18ec08",
  null
  
)

export default component.exports